/********************
 * SHOP THIS SCENE GALLERY
 */
// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

if ($('.template-page-gallery').length > 0) {
  $stsGallery = $('.gallery'); // Gallery container
  $stsShopButton = $stsGallery.find('button[data-quick-view-handles]'); // Gallery button
  $stsSlick = $stsGallery.find('.gallery__images'); // Main slideshow container for slick

  // Subscribe to afterChange event
  $stsSlick.on('init reInit afterChange', shopThisSceneSlickHandler);

  // Slick initialization
  $stsSlick.slick({
    infinite: true,
    lazyLoad: 'ondemand',
    prevArrow: '<button class="gallery__prev"></button>',
    nextArrow: '<button class="gallery__next"></button>',
    dots: true,
    autoplay: false,
    initialSlide: 0,
    cssEase: 'linear',
    speed: 200,
    fade: true,
    customPaging: (slider, i) =>
      i + 1 + ' <span>of</span> ' + slider.slideCount,
  });

  $(document).ready(function () {
    if ($stsSlick.length && $(window).width() > 768) {
      // Note: Keydown events are firing shortly after page load on the dev and prod sites but not locally. Not sure why, could be one of our plugins.
      $stsSlick.on('mousemove', getCursorPositionSide);
      $stsSlick.on('click', slideControler);
      $(this).keyup(function (e) {
        if (e.keyCode == '37' || e.keyCode == '39') {
          e.preventDefault();
          slideControler(e);
        }
      });
    } else {
      $stsSlick.on('click', slideControler);
    }
  });

  function slideControler(event = null) {
    if (event.type == 'keyup' && event.keyCode) {
      if (event.keyCode == '37') return $stsSlick.slick('slickPrev');
      if (event.keyCode == '39') return $stsSlick.slick('slickNext');
    } else {
      return event.pageX > $stsSlick.width() / 2
        ? $stsSlick.slick('slickNext')
        : $stsSlick.slick('slickPrev');
    }
  }

  function changeCursor(side = '') {
    const opposite = side == 'left' ? 'right' : 'left';
    if ($stsSlick.hasClass(`gallery__images--${opposite}`))
      $stsSlick.removeClass(`gallery__images--${opposite}`);
    if (!$stsSlick.hasClass(`gallery__images--${side}`))
      $stsSlick.addClass(`gallery__images--${side}`);
  }

  function getCursorPositionSide(event = null) {
    return event.pageX > $stsSlick.width() / 2
      ? changeCursor('right')
      : changeCursor('left');
  }

  // Get the current product handles from the current slide
  function getCurrentProductHandles($currentSlide = null) {
    if (!$currentSlide) return;
    const $currentProductElement = $currentSlide.find('[data-product-handles]');
    return $currentProductElement.data('product-handles');
  }

  // Set the Shop this scene button attributes
  function setShopButtonProducts(currentProductHandles) {
    $stsShopButton.data('quick-view-handles', currentProductHandles);
    return currentProductHandles !== ''
      ? $stsShopButton.show()
      : $stsShopButton.hide();
  }

  // Handler for Slick
  function shopThisSceneSlickHandler(e, slick, currentSlideIndex) {
    const $currentSlide = $(this).find('.slick-current');
    const currentProductHandles = getCurrentProductHandles($currentSlide);
    setShopButtonProducts(currentProductHandles);

    if (e.type == 'afterChange') {
      pushGalleryGAEvent(currentSlideIndex);
    }
  }

  // Push GTM event of which slide they are seeing now
  function pushGalleryGAEvent(index = null) {
    const slideNo = index ? index + 1 : 1;
    const data = {
      eventCategory: 'Gallery',
      eventAction: 'Hero - Carousel',
      eventLabel: slideNo,
    };
    custom.gtmDatalayer.gtmPush(data);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/src/custom/gallery.js